export const contractTemplateModule = {
  entrustWithholdContractTemplate: 'entrustWithholdContractTemplate', // 委托划扣协议模版
}
